import { createSlice } from "@reduxjs/toolkit";
import { allCausePreferenceAPI, updateCausePreferenceAPI, userCausePreferenceAPI } from "../../../api/publicApi";
import { CausePreferenceAPIProps } from "../../../utils/types";
import { showErrorToast, showSuccessToast } from "../../../utils/toast";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
  userData: null,
};

const causePreference = createSlice({
  name: "causePreference",
  initialState: data,
  reducers: {
    causePreference(state) {
      state.isLoading = true;
    },
    causePreferenceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = null;
    },
    updateCausePreferenceSuccess(state, action) {
      state.isLoading = false;
      state.message = action.payload.message;
    },
    userCausePreferenceSuccess(state, action) {
      state.isLoading = false;
      state.userData = action.payload;
      state.message = action.payload.message;
    },
    causePreferenceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    causePreferenceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const userCausePreferHandler = (user_id: string) => async (dispatch: any) => {
  try {
    dispatch(causePreferenceAction.causePreference());
    const response: any = await userCausePreferenceAPI(user_id);
    dispatch(causePreferenceAction.userCausePreferenceSuccess(response));
  } catch (e: any) {
    dispatch(causePreferenceAction.causePreferenceFailure(e?.response?.data?.message));
    dispatch(causePreferenceAction.causePreferenceReset());
  }
};
export const allCausePreferHandler = () => async (dispatch: any) => {
  try {
    dispatch(causePreferenceAction.causePreference());
    const response: any = await allCausePreferenceAPI();
    dispatch(causePreferenceAction.causePreferenceSuccess(response));
  } catch (e: any) {
    dispatch(causePreferenceAction.causePreferenceFailure(e?.response?.data?.message));
    dispatch(causePreferenceAction.causePreferenceReset());
  }
};

export const updateCausePreference=(user_id:string,data:CausePreferenceAPIProps) => async (dispatch: any) => {
  try {
    dispatch(causePreferenceAction.causePreference());
    const response: any = await updateCausePreferenceAPI(user_id,data);
    dispatch(causePreferenceAction.updateCausePreferenceSuccess(response));
    showSuccessToast(response?.message)
  } catch (e: any) {
    dispatch(causePreferenceAction.causePreferenceFailure(e?.response?.data?.message));
    showErrorToast(e?.response?.data?.error_message)
  }
};
export default causePreference.reducer;
export const causePreferenceAction = causePreference.actions;
